export default __webpack_public_path__ + "static/media/amortization-strut.917fbc78.png";